module.exports = __webpack_public_path__ + "static/media/Threat & Attack Vectors.730faba2.png";